module.exports = __webpack_public_path__ + "assets/img/culture-item-three.d2676057.png";